<template>
<div>
  <div v-if="job.salaryMin !== null && job.salaryMax !== null" v-tooltip="'Min — Max salary range'">
    <currency :val="job.salaryMin" :currency="job.salaryCurrency" /> - <currency :val="job.salaryMax" :currency="job.salaryCurrency"/>
  </div>
  <div v-else-if="job.salaryMin !== null && job.salaryMax === null" v-tooltip="'Minimum Salary'">
    <currency :val="job.salaryMin" :currency="job.salaryCurrency" />
  </div>
  <div v-else-if="job.salaryMin === null && job.salaryMax !== null" v-tooltip="'Estimated Salary'">
    <currency :val="job.salaryMax" :currency="job.salaryCurrency" />
  </div>
  <div v-else>{{this.$t('widget.negotiable')}}</div>
</div>
</template>

<script>
import Currency from '@/components/general/currency'
import {toCurrency} from '@/helpers/currency-helper'

export default {
  components: { Currency },
  props: {
    job: {
      type: Object,
      required: true
    }
  },
  methods: {
    salary (job) {
      if (job.salaryMin !== null && job.salaryMax !== null) return toCurrency(job.salaryMin, job.salaryCurrency) + ' - ' + toCurrency(job.salaryMax, job.salaryCurrency)
      else if (job.salaryMax !== null) return toCurrency(job.salaryMax, job.salaryCurrency)
      else if (job.salaryMin !== null) return toCurrency(job.salaryMin, job.salaryCurrency)
      else return 'Negotiable'
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  display: inline;
}
</style>



// WEBPACK FOOTER //
// src/components/general/job-salary.vue